<template>
  <div class="HotNew">
    <div
      class="HotNew_type"
      :class="[language == 'zh' ? 'zhFamilytitle' : 'enfamilytitle']"
    >
      <div class="HotNew_type_content" @click="toNewList(1)">
        <div class="HotNew_type_content_txt">{{ $t("NewList.Society") }}</div>
        <div
          class="Triangle"
          v-show="activeType == 1"
          style="border-top: 10px solid #4a9e46"
        ></div>
      </div>
      <div class="HotNew_type_content" @click="toNewList(2)">
        <div class="HotNew_type_content_txt">{{ $t("NewList.Science") }}</div>
        <div
          class="Triangle"
          v-show="activeType == 2"
          style="border-top: 10px solid #006a9d"
        ></div>
      </div>
      <div class="HotNew_type_content" @click="toNewList(3)">
        <div class="HotNew_type_content_txt">{{ $t("NewList.Practices") }}</div>
        <div
          class="Triangle"
          v-show="activeType == 3"
          style="border-top: 10px solid #db1868"
        ></div>
      </div>
    </div>
    <div
      class="HotNew_list"
      :style="{
        'background-image': activeType == 1 ? `url(${url1})` : `url(${url2})`,
      }"
    >
      <div class="HotNew_list_content">
        <div
          :style="{
            lineHeight: language == 'zh' ? '30px' : '22px',
          }"
        >
          <div class="HotNew_list_content_left" v-if="activeType == 1">
            <p class="tit" v-if="activeType == 1">
              {{ $t("NewList.Society") }}
            </p>

            <p class="content">{{ $t("NewList.SocietyDescription") }}</p>
          </div>
          <div class="HotNew_list_content_left" v-if="activeType == 2">
            <p class="tit">{{ $t("NewList.Science") }}</p>
            <p class="content">{{ $t("NewList.ScienceDescription") }}</p>
          </div>
          <div class="HotNew_list_content_left" v-if="activeType == 3">
            <p class="tit">{{ $t("NewList.Practices") }}</p>
            <p class="content">{{ $t("NewList.CaseDescription") }}</p>
          </div>
        </div>

        <div class="HotNew_list_content_right" v-if="terminal == 'pc'">
          <ul v-if="dataList">
            <li
              style="background: rgba(162, 25, 66, 0.9)"
              v-for="(item, index) in dataList.slice(0, 4)"
              :key="index"
              @click="toArticles(item.id)"
            >
              <div class="img_box">
                <img :src="`${GLOBAL.imageUrl}${item.icon}`" alt />
              </div>

              <div
                class="txt"
                :class="[language == 'zh' ? 'zhFamilytitle' : 'enfamilytitle']"
              >
                <p>
                  {{ item.title }}
                </p>
                <div class="date">
                  <div>{{ item.releaseTime }}</div>
                  <div>
                    <i class="iconfont icon-jiantou"></i>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  props: ["activeType", "dataList"],
  name: "HotNew",
  data() {
    return {
      url1: require("../../../assets/image/NewsList/NewsSocietyBanner.png"),
      url2: require("../../../assets/image/NewsList/NewsTechnologyBanner.png"),
    };
  },
  mounted() {},
  methods: {
    toNewList(val) {
      if (val == 1) {
        this.$router.push(`/newslist?type=Society`);
      } else if (val == 2) {
        this.$router.push(`/newslist?type=Technology`);
      } else if (val == 3) {
        this.$router.push(`/newslist?type=Case`);
      }
    },
    toArticles(id) {
      this.$router.push(`/articles?id=${id}`);
    },
  },
};
</script>

<style scoped lang="scss">
@media screen and (min-width: 1026px) {
  .HotNew {
    width: 100%;
    height: 580px;
    margin-bottom: 14px;
    .HotNew_type {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 60px;
      margin-bottom: 14px;
      .HotNew_type_content:nth-child(1) {
        background: #4a9e46;
      }
      .HotNew_type_content:nth-child(2) {
        background: #006a9d;
        margin: 0 6px;
      }
      .HotNew_type_content:nth-child(3) {
        background: #db1868;
      }
      .HotNew_type_content:hover {
        opacity: 0.7;
        transition: 0.2s;
      }
      .HotNew_type_content {
        cursor: pointer;
        flex: 1;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        .HotNew_type_content_txt {
          color: #fff;
        }
        .Triangle {
          position: absolute;
          bottom: -8px;
          left: 50%;
          margin-left: -10px;
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          // border-top: 10px solid ;
        }
      }
    }
    .HotNew_list {
      width: 100%;
      height: 520px;
      // background: url("../../../assets/image/NewsList/NewsSocietyBanner.png") no-repeat;
      background-size: 100% 100%;
      .HotNew_list_content {
        width: 1200px;
        height: 100%;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .HotNew_list_content_left {
          width: 420px;
          height: 420px;
          padding: 10px 20px;
          background: rgba(255, 255, 255, 0.8);
          overflow-y: auto;
          .tit {
            font-size: 40px;
            line-height: 46px;
            color: #000;
            margin: 20px 0px 20px 0;
          }
          .content {
            font-size: 16px;
            color: #000;
          }
        }
        .HotNew_list_content_right {
          ul {
            display: flex;
            flex-direction: column;
            width: 460px;
            li {
              height: 97px;

              width: 100%;
              display: flex;
              flex-direction: row;
              margin-bottom: 10px;
              .img_box {
                width: 130px;
                height: 97px;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }

              .txt {
                flex: 1;
                padding: 15px;

                p {
                  color: rgba(255, 255, 255, 1);
                  font-size: 14px !important;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                }
                .date {
                  margin-top: 14px;
                  color: rgba(255, 255, 255, 1);
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .HotNew {
    width: 100%;
    height: 580px;
    margin-bottom: 14px;
    .HotNew_type {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 60px;
      margin-bottom: 14px;
      .HotNew_type_content:nth-child(1) {
        background: #4a9e46;
      }
      .HotNew_type_content:nth-child(2) {
        background: #006a9d;
        margin: 0 6px;
      }
      .HotNew_type_content:nth-child(3) {
        background: #db1868;
      }
      .HotNew_type_content:hover {
        opacity: 0.7;
        transition: 0.2s;
      }
      .HotNew_type_content {
        cursor: pointer;
        flex: 1;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        .HotNew_type_content_txt {
          color: #fff;
        }
        .Triangle {
          position: absolute;
          bottom: -8px;
          left: 50%;
          margin-left: -10px;
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          // border-top: 10px solid ;
        }
      }
    }
    .HotNew_list {
      width: 100%;
      height: 520px;
      // background: url("../../../assets/image/NewsList/NewsSocietyBanner.png") no-repeat;
      background-size: 100% 100%;
      .HotNew_list_content {
        width: 1200px;
        height: 100%;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .HotNew_list_content_left {
          width: 360px;
          height: 420px;
          padding: 20px;
          background: rgba(255, 255, 255, 0.8);
          .tit {
            font-size: 40px;
            color: #000;
            margin: 20px 0 7px 0;
          }
          .content {
            font-size: 16px;
            color: #000;
          }
        }
        .HotNew_list_content_right {
          ul {
            display: flex;
            flex-direction: column;
            width: 460px;
            li {
              height: 97px;

              width: 100%;
              display: flex;
              flex-direction: row;
              margin-bottom: 10px;
              .img_box {
                width: 130px;
                height: 97px;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }

              .txt {
                flex: 1;
                padding: 15px;
                p {
                  color: rgba(255, 255, 255, 1);
                  font-size: 14px !important;
                }
                .date {
                  margin-top: 14px;
                  color: rgba(255, 255, 255, 1);
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .HotNew {
    width: 100%;
    // height: 580px;
    margin-bottom: 14px;
    .HotNew_type {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 60px;
      margin-bottom: 14px;
      .HotNew_type_content:nth-child(1) {
        background: #4a9e46;
      }
      .HotNew_type_content:nth-child(2) {
        background: #006a9d;
        margin: 0 6px;
      }
      .HotNew_type_content:nth-child(3) {
        background: #db1868;
      }
      .HotNew_type_content:hover {
        opacity: 0.7;
        transition: 0.2s;
      }
      .HotNew_type_content {
        cursor: pointer;
        flex: 1;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        .HotNew_type_content_txt {
          color: #fff;
          font-weight: 600;
          font-size: 16px;
          text-align: center;
        }
        .Triangle {
          position: absolute;
          bottom: -8px;
          left: 50%;
          margin-left: -10px;
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          // border-top: 10px solid ;
        }
      }
    }
    .HotNew_list {
      width: 100%;
      // height: 520px;
      // background: url("../../../assets/image/NewsList/NewsSocietyBanner.png") no-repeat;
      background-size: 100% 100%;
      .HotNew_list_content {
        // width: 100%;
        padding: 20px 20px;
        height: 100%;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .HotNew_list_content_left {
          width: 100%;
          // height: 420px;
          padding: 20px;
          background: rgba(255, 255, 255, 0.8);
          .tit {
            font-size: 26px;
            font-weight: 600;
            color: #000;
            margin: 10px 0 7px 0;
          }
          .content {
            font-size: 16px;
            color: #000;
          }
        }
        .HotNew_list_content_right {
          ul {
            display: flex;
            flex-direction: column;
            width: 460px;
            li {
              height: 97px;

              width: 100%;
              display: flex;
              flex-direction: row;
              margin-bottom: 10px;
              .img_box {
                width: 130px;
                height: 97px;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }

              .txt {
                flex: 1;
                padding: 15px;
                p {
                  color: rgba(255, 255, 255, 1);
                  font-size: 14px !important;
                }
                .date {
                  margin-top: 14px;
                  color: rgba(255, 255, 255, 1);
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>